/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const financialsRetentionSegmentDtoSchema = z.object({
  label: z.optional(z.string()),
  value: z.string().nullish(),
});
